import { Chip, styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { type ShortcutList } from './shortcuts';

type Props = {
    shortcutList: ShortcutList;
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    }
}));

const StyledTableCell = styled(TableCell)(() => ({
    '&': {
        border: 0
    }
}));

export default function ShortcutTable(props: Props) {
    const { t } = useTranslation(['whiteboard', 'common']);

    return (
        <TableContainer>
            <Table size="small">
                <TableBody>
                    {props.shortcutList.shortcuts.map((shortcut) => (
                        <StyledTableRow
                            key={shortcut.name}
                        >
                            <StyledTableCell scope="row">
                                {t(shortcut.name)}
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                {typeof shortcut.command === 'string' &&
                                    <Chip label={t(shortcut.command)}/>
                                }
                                {Array.isArray(shortcut.command) && shortcut.command.map((command, index) => (
                                    <span key={index}>
                                        <Chip label={t(command)}/>
                                        {index + 1 < shortcut.command.length &&
                                            <span style={{ marginLeft: '5px', marginRight: '5px' }}>
                                                {shortcut.separator ?? t('whiteboard:helpDialog.or')}
                                            </span>
                                        }
                                    </span>
                                ))}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
